// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function make(top, right, bottom, left) {
  return {
          top: top,
          right: right,
          bottom: bottom,
          left: left
        };
}

var Margin = {
  make: make
};

function make$1(left, right) {
  return {
          left: left,
          right: right
        };
}

var Padding = {
  make: make$1
};

function make$2(fontSize, angle, position) {
  return function (param, param$1, param$2) {
    return {
            fontSize: fontSize,
            angle: angle,
            position: position,
            textAnchor: param,
            width: param$1,
            scaleToFit: param$2
          };
  };
}

var Tick = {
  make: make$2
};

function make$3(fill) {
  return {
          fill: fill
        };
}

var Cursor = {
  make: make$3
};

var LineChart = {};

var AreaChart = {};

var BarChart = {};

var Line = {};

var Area = {};

var CartesianGrid = {};

var ReferenceLine = {};

var AxisInterval = {};

var XAxis = {};

var YAxis = {};

var Tooltip = {};

var Legend = {};

var ComposedChart = {};

var Bar = {};

var Scatter = {};

var LabelList = {};

var ResponsiveContainer = {};

var Brush = {};

var PieChart = {};

var Pie = {};

var Cell = {};

exports.Margin = Margin;
exports.Padding = Padding;
exports.Tick = Tick;
exports.Cursor = Cursor;
exports.LineChart = LineChart;
exports.AreaChart = AreaChart;
exports.BarChart = BarChart;
exports.Line = Line;
exports.Area = Area;
exports.CartesianGrid = CartesianGrid;
exports.ReferenceLine = ReferenceLine;
exports.AxisInterval = AxisInterval;
exports.XAxis = XAxis;
exports.YAxis = YAxis;
exports.Tooltip = Tooltip;
exports.Legend = Legend;
exports.ComposedChart = ComposedChart;
exports.Bar = Bar;
exports.Scatter = Scatter;
exports.LabelList = LabelList;
exports.ResponsiveContainer = ResponsiveContainer;
exports.Brush = Brush;
exports.PieChart = PieChart;
exports.Pie = Pie;
exports.Cell = Cell;
/* No side effect */
